import React from 'react';
import PricingPageTableHeader from './PricingPageTableHeader';
import useStyles from './styles';
import PurchaseNowButton from '../PurchaseNowButton';
import { ProductCodes } from '../../../../../types/products';

const TeleprompterPricingPageTableHeader = () => {
  const classes = useStyles();

  return (
    <PricingPageTableHeader>
      <div className={classes.title}>Teleprompter</div>
      <div className={classes.description}>
        For those who want to use PitchHub's® teleprompter and media management software
      </div>
      <div className={classes.planTitle}>
        $199
        {' '}
        <span className={classes.planDuration}>/ year</span>
      </div>
      <div className={classes.planDescription}>
        Billed annually (save 12%)
      </div>
      <div className={classes.buttonWrapper}>
        <PurchaseNowButton productCode={ProductCodes.TeleprompterAnnual} />
      </div>
      <div className={classes.planTitle}>
        $19
        {' '}
        <span className={classes.planDuration}>/ month</span>
      </div>
      <div className={classes.planDescription}>
        Billed monthly
      </div>
      <PurchaseNowButton productCode={ProductCodes.TeleprompterMonthly} variant="outlined"/>
    </PricingPageTableHeader>
  );
};

export default TeleprompterPricingPageTableHeader;
